<script setup>
import { usePrivateMedia } from 'dashboard/composables/usePrivateMedia';
import { ref } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});
const hasError = ref(false);
const showGallery = ref(false);

const { filteredCurrentChatAttachments } = useMessageContext();

const handleError = () => {
  hasError.value = true;
};
const { mediaUrl, mediaError, mediaLoading, retryMedia, mediaFailed, mediaLoaded } = usePrivateMedia(() => props.attachment.dataUrl);
</script>

<template>
  <div
    class="size-[72px] overflow-hidden contain-content rounded-xl cursor-pointer"
    @click="showGallery = true"
  >
    <div
      v-if="mediaError"
      class="flex flex-col items-center justify-center gap-1 text-xs text-center rounded-lg size-full bg-n-alpha-1 text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <button v-if="mediaError" type="button" class="px-3 py-2 rounded border border-n-weak text-n-blue-11" :disabled="mediaLoading" @click.stop="retryMedia">{{ $t('DEVLIVE_MEDIA.RETRY') }}</button>
    <img
      v-if="mediaUrl"
      class="object-cover w-full h-full skip-context-menu"
      :src="mediaUrl || undefined"
      @error="mediaFailed" @load="mediaLoaded"
    />
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
